<template>
    <div>
        <v-list-item class="mt-3">
            <h5 class="px-2">{{ label }}</h5>
        </v-list-item>
        <v-list-item
            v-for="(menu, index) in items"
            :key="'skel-' + index + '-' + label"
            link
        >
            <v-list-item-content>
                <v-skeleton-loader
                    ref="skeleton"
                    type="list-item"
                    class="mx-auto"
                ></v-skeleton-loader>
            </v-list-item-content>
        </v-list-item>
    </div>
</template>

<script>
export default {
    props: {
        label: { type: String, default: '' },
        items: { type: Array, default: () => [] }
    },


}
</script>